import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        form: '=',
        context: '=',
        canManageCourse: '<',
        trainingForm: '=',
        key: '<',
        trainingTypes: '<',
        hasPlanningGroups: '<',
        ckconfig: '<',
        isDisabled: '<'
    },
    template: `
        <form-row error="vm.form.errors.courseTrainings[vm.key].courseTrainingI18ns[vm.defaultLanguage].name">
            <label class="label">{{ 'courses.Training name' | translate }} *</label>
            <div class="items">
                <input ng-disabled="!vm.canManageCourse" type="text" class="form-control"
                ng-model="vm.trainingForm.courseTrainingI18ns[vm.defaultLanguage].name">
                <form-row-error></form-row-error>
            </div>
        </form-row>
        <form-row error="vm.form.errors.courseTrainings[vm.key].file">
            <label class="label">{{ 'courses.Training image' | translate}}</label>
            <div class="items">
                <input ng-disabled="!vm.canManageCourse" ngf-select="vm.CourseVersionTrainingFormFileService.setImage($file, vm.trainingForm)" ng-model="vm.trainingForm.file" type="file" />
                <form-row-error></form-row-error>
            </div>
        </form-row>
        <form-row ng-if="vm.trainingForm.imageFilename">
            <label class="label"></label>
            <div class="items">
                <div class="form-img">
                    <img ng-src="{{ vm.CourseVersionService.getTrainingImageUrl(vm.trainingForm, vm.form.model.companyId, 'small') }}">
                    <ul class="actions01">
                        <li><a class="btn delete" ng-click="vm.CourseVersionTrainingFormFileService.deleteImage(vm.trainingForm)"
                        >{{ 'general.Remove' | translate }}</a></li>
                    </ul>
                </div>
            </div>
        </form-row>
        <form-row error="vm.form.errors.courseTrainings[vm.key].passingType">
            <span class="label">
                {{ 'training.Required for completion' | translate }} *
                <tooltip html="vm.tooltipTexts.passingType" />
            </span>
            <div class="items">
                <ul class="checkboxes">
                    <li>
                        <label
                            ng-disabled="vm.isDisabled"
                            ng-repeat="value in vm.COURSE_TRAINING_PASSING_TYPE_ENUM.KEYS"
                        >
                            <input
                                ng-disabled="vm.isDisabled"
                                name="r02"
                                type="radio"
                                ng-model="vm.trainingForm.passingType"
                                ng-value="'{{ value }}'"
                            >{{ vm.COURSE_TRAINING_PASSING_TYPE_ENUM.LABELS[value] }}
                        </label>
                    </li>
                </ul>
            </div>
        </form-row>
        <form-row error="vm.form.errors.courseTrainings[vm.key].type">
            <span class="label">{{ 'courses.Type' | translate }} *</span>
            <div class="items">
                <ul class="checkboxes">
                    <li>
                        <label ng-repeat="value in vm.trainingTypes" ng-if="!vm.form.model.isWithoutPlanning">
                            <input ng-disabled="vm.isDisabled || vm.hasPlanningGroups"
                            ng-click="vm.CourseVersionTrainingFormService.finalizePassingType(vm.trainingForm)"
                            name="r01"
                            type="radio"
                            ng-model="vm.trainingForm.type"
                            ng-value="'{{ value }}'"> {{ vm.COURSE_TRAINING_TYPE_ENUM.LABELS[value] }}
                        </label>
                    </li>
                </ul>
            </div>
        </form-row>
        <form-row error="vm.form.errors.courseTrainings[vm.key].courseTrainingI18ns[vm.defaultLanguage].description">
            <label class="label">
                {{ 'courses.Description' | translate }}
                <tooltip html="vm.tooltipTexts.description" />
            </label>
            <div class="items">
                <ng-ckeditor
                    ng-model="vm.trainingForm.courseTrainingI18ns[vm.defaultLanguage].description"
                    class="mt10"
                    ng-config="vm.ckconfig">
                </ng-ckeditor>
            </div>
        </form-row>
        <form-row error="vm.form.errors.courseTrainings[vm.key].learndashCourseId">
            <label class="label">{{ 'courses.Learning materials' | translate }}</label>
            <div class="items">
                <select ng-disabled="vm.isDisabled" class="form-control"
                    ng-model="vm.trainingForm.learndashCourseId"
                    ng-change="vm.CourseVersionTrainingFormLearndashService.getLearndashCourse(vm.trainingForm)"
                    ng-options="course.ID as course.post_title for course in vm.CourseVersionTrainingFormLearndashService.learndashCourses">
                    <option value=""></option>
                </select>
                <p class="desc warn" ng-if="!vm.CourseVersionTrainingFormLearndashService.hasAccessToLdStudyMaterials(vm.trainingForm.learndashCourseId)">
                    {{ 'courses.Saved value is not displayed. You do not have access to the attached material' | translate }}
                </p>
                <a
                    class="btn add"
                    ng-if="!vm.isDisabled
                     && (vm.PrivilegeService.canManageMaterials() || vm.CourseVersionTrainingFormLearndashService.hasManageMaterialsPrivilegeSite())
                     && vm.CourseVersionTrainingFormLearndashService.hasAccessToLdStudyMaterials(vm.trainingForm.learndashCourseId)"
                    ng-click="vm.CourseVersionTrainingFormLearndashService.addLdMaterial(vm.trainingForm)"
                >
                    {{ 'courses.Add study material' | translate }}
                </a>
                <a
                    class="btn edit"
                    ng-if="vm.canManageCourse
                     && vm.PrivilegeService.canManageMaterials()
                     && vm.trainingForm.canEditLearndashCourse
                     && vm.CourseVersionTrainingFormLearndashService.showLearndashCourseEditLink
                     && vm.CourseVersionTrainingFormLearndashService.hasAccessToLdStudyMaterials(vm.trainingForm.learndashCourseId)"
                    ng-click="vm.CourseVersionTrainingFormLearndashService.editLdMaterial(vm.trainingForm)"
                >
                    {{ 'courses.Edit study material' | translate }}
                </a>
            </div>
        </form-row>
        <form-row error="vm.form.errors.courseTrainings[vm.key].duration">
            <label class="label">{{ 'training.Expected duration (h)' | translate }}</label>
            <div class="items">
                <input ng-disabled="!vm.canManageCourse"
                    type="text" ng-model="vm.trainingForm.duration" class="form-control">
                <form-row-error></form-row-error>
            </div>
        </form-row>
        <div class="heading01 ng-scope" >
            <h3>{{ 'training.External Study Materials' | translate }}</h3>
        </div>
        <form-row error="vm.form.errors.courseTrainings[vm.key].externalMaterialUrl">
            <label class="label">{{ 'training.URL' | translate }}</label>
            <div class="items">
                <input ng-disabled="vm.isDisabled"
                    type="text" ng-model="vm.trainingForm.externalMaterialUrl" class="form-control">
                <form-row-error></form-row-error>
            </div>
        </form-row>
        <form-row error="vm.form.errors.courseTrainings[vm.key].externalMaterialLinkTitle">
            <label class="label">{{ 'training.Title' | translate }}</label>
            <div class="items">
                <input ng-disabled="vm.isDisabled"
                    type="text" ng-model="vm.trainingForm.externalMaterialLinkTitle" class="form-control">
                <form-row-error></form-row-error>
            </div>
        </form-row>
        <div class="mt20">
            <file-manager
                entity-type="'course_training'"
                entity-id="vm.trainingForm.id">
            </file-manager>
        </div>
    `
})

export default class {
    constructor (TokenService, CourseVersionService, PrivilegeService, CourseVersionTrainingFormService,
                 CourseVersionTrainingFormLearndashService, CourseVersionTrainingFormFileService, COURSE_TRAINING_TYPE_ENUM,
                 COURSE_TRAINING_PASSING_TYPE_ENUM, $translate) {
        this.TokenService = TokenService;
        this.CourseVersionService = CourseVersionService;
        this.PrivilegeService = PrivilegeService;
        this.CourseVersionTrainingFormService = CourseVersionTrainingFormService;
        this.CourseVersionTrainingFormLearndashService = CourseVersionTrainingFormLearndashService;
        this.CourseVersionTrainingFormFileService = CourseVersionTrainingFormFileService;
        this.COURSE_TRAINING_TYPE_ENUM = COURSE_TRAINING_TYPE_ENUM;
        this.COURSE_TRAINING_PASSING_TYPE_ENUM = COURSE_TRAINING_PASSING_TYPE_ENUM;
        this.defaultLanguage = TokenService.getCompanyLanguage();
        this.$translate = $translate;
    }

    $onInit () {
        // get the course in order to assign showLearndashCourseEditLink the right way
        this.CourseVersionTrainingFormLearndashService.getLearndashCourse(this.trainingForm);

        this.tooltipTexts = {
            passingType: this.$translate.instant('courses.Training passing type tooltip'),
            description: this.$translate.instant('courses.Training description tooltip')
        };
    }
}



// WEBPACK FOOTER //
// ./src/app/components/courses/courses/steps/version/training/classroom/index.js